var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mbti f-14 m-l-4 f-medium",domProps:{"innerHTML":_vm._s(_vm.matchResult(_vm.match))}})}
var staticRenderFns = []

export { render, staticRenderFns }